/* Func = limiting Scope for this file */
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    if(!(window.ActiveXObject) && "ActiveXObject" in window) {

        /*is explorer*/
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }

                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    }

    /* Text and Form Animations */
    let formModule = document.querySelectorAll('.form-module-wrapper form');
    let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
    if(formModule){
        formModule.forEach(function(form_module) {
            form_module.classList.add('animate-fade', 'top');
        });
    }
    if(textModule){
        textModule.forEach(function(text_module) {
            text_module.classList.add('animate-fade', 'top');
        });
    }

    /* Opening and Closing Menu */
    let Body = document.body;

    document.addEventListener('DOMContentLoaded', () => {

        // Main Nav Dropdown
        let primaryNav = document.getElementById('primary-nav');
        if(primaryNav){
            primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
            });
        }

        /* Lightbox Gallerys */
        const customLightbox = new LBX('.js-lbx-gallery', {
            customClass:'lbx-gallery',
        });

    });

    window.addEventListener("load", function() {
        scrollW();
        window.addEventListener('scroll', function(){
            scrollW();
        });
    });

    /* Remove empty <p> tags created by tinymce */
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    /* Swiper Sliders */

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        const imaSlider = new Swiper('.images-sliders', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            },
            navigation: {
                nextEl: ".sw-but-img-next",
                prevEl: ".sw-but-img-prev",
            },
        });
    }

    let gallerySlide = document.querySelectorAll('.gallery-slider');
    if(gallerySlide){
        const gallerySlider = new Swiper('.gallery-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            },
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
        });
    }
    
    let galleryFlex = document.querySelectorAll('.galleryFlex_list');
    if(galleryFlex){
        const swiperFlex = new Swiper('.galleryFlex_list', {
            autoplay: {
                delay: 4000,
            },
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            breakpoints: {
                840: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            },

        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-top', {
                /*Optional parameters*/
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                /* If we need pagination */
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                }
            });
        });
    }

    let carouselSlide = document.querySelectorAll('.carousel-slider');
    if(carouselSlide){
        const carouselSlider = new Swiper('.carousel-slider', {
            loop: true,
            slidesPerView: 1,
            autoHeight: true,
            freeMode: true,
            navigation: {
                nextEl: ".sw-car-next",
                prevEl: ".sw-car-prev",
            },
            breakpoints: {
                840: {
                    slidesPerView: 3,
                    autoHeight: false,
                },
                700: {
                    slidesPerView: 2,
                    autoHeight: false,
                },
            },
        });
    }

    let sliderSlide = document.querySelectorAll('.slider-slide');
    if(sliderSlide){
        const sliderSlider = new Swiper('.slider-slide', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            autoHeight: true,
            fadeEffect: {
                "crossFade": true
            },
            /* If we need pagination */
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                640: {
                    autoHeight: false,
                },
            },
        });
    }

    let reviewsSlider = document.querySelectorAll('.reviews-slides');
    if(reviewsSlider){
        reviewsSlider.forEach((item)=> {
            new Swiper('.reviews-slides', {
                autoHeight: true,
                loop: false,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.slider-pagination',
                    clickable: true,
                }
            });
        });
    }

    let historySlide = document.querySelectorAll('.history-slide');
    if(historySlide){
        const historySlider = new Swiper('.history-slide', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            autoHeight: true,
            fadeEffect: {
                "crossFade": true
            },
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                600: {
                    autoHeight: false,
                },
            },
        });
    }

    let locationTap = document.querySelectorAll('.location-int-block');
    let locationSlide = document.querySelectorAll('.location-slider');
    if(locationSlide){
        const locationSlider = new Swiper('.location-slider', {
            /*Optional parameters*/
            loop: true,
            effect: "fade",
            fadeEffect: {
                "crossFade": true
            }
        });
        locationTap.forEach(function(hB,hBc) {
            let hNav = hB.querySelectorAll('.location-point');
            hNav.forEach(function(h_nav) {
                let navCount = h_nav.dataset.nav;
                h_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(locationTap.length > 1){
                        locationSlider[hBc].slideTo(navCount, 1000);
                    } else {
                        locationSlider.slideTo(navCount, 1000);
                    }
                    hNav.forEach(function(h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(locationTap.length > 1){
                    locationSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider[hBc].realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    locationSlider.on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(locationSlider.realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                }
            });
        });
    }

    let carouselColumnsSlide = document.querySelectorAll('.carousel-columns-slide');
    if(carouselColumnsSlide){
        const carouselColumnsSlider = new Swiper('.carousel-columns-slide', {
            watchSlidesProgress: true,
            slidesPerView: 1,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: ".sw-but-next",
                prevEl: ".sw-but-prev",
            },
            breakpoints: {
                840: {
                    slidesPerView: 3,
                    autoHeight: false,
                },
                700: {
                    slidesPerView: 2,
                    autoHeight: false,
                },
            },
        });
    }

    /* Scroll Intro*/
    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    /* FAQ */
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    /* Anchor Animation */
    let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-lbx], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default))");
    if(aHref){
        aHref.forEach(function(a_href) {
            a_href.addEventListener('click', function(e){
                e.preventDefault();
                let strAnchor = this.hash.slice(1);
                animateto(strAnchor);
            });
        });
    }

    /*MOBILE MENU NAV
	****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtn = document.getElementById('menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    /* Open Navigation */
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Html.classList.add('hide-overflow');
            Navigation[0].classList.add('open');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        /* Sub-Navigation */
        /* Open active sub-nav on load */
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });

        /* Toggle open/close on tap */
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }

    /* Close Navigation */
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

    let screenHeight = document.documentElement.clientHeight;
    let homeTopImg = document.getElementById('home');
    if(homeTopImg){
        homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
            entry.style.height = screenHeight+'px';
        });
        window.addEventListener("resize", function(){
            screenHeight = document.documentElement.clientHeight;
            homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
                entry.style.height = screenHeight+'px';
            });
        });
    }

    let aBtn = document.querySelectorAll(".btn:not(.attractions-map__expand), .signup-btn");
    if(aBtn){
        setTimeout(() => {
            aBtn.forEach(function(a_btn) {
                let htmlString = a_btn.innerText;
                a_btn.innerHTML = '<span>'+htmlString+'</span>';
            });
        }, "1000");
    }

    let pressForm = document.querySelectorAll(".press-awards .form-module-wrapper");
    let btnForm = document.querySelectorAll(".press-awards .btn-form");
    if(pressForm){
        pressForm.forEach(function(press_form) {
            press_form.classList.add("close-out");
            press_form.querySelector('.form-module').insertAdjacentHTML('afterbegin', '<div id="js_form_close" class="close-icon"><div class="lines"><div class="line"></div><div class="line"></div></div><div class="text">Close</div></div>');
        });
        btnForm.forEach(function(btn_form) {
            btn_form.addEventListener('click', function(e){
                e.preventDefault();
                pressForm.forEach(function(press_form) {
                    if(press_form.classList.contains("close-out")){
                        press_form.classList.remove("close-out");
                    } else {
                        press_form.classList.add("close-out");
                    }
                });
            });
            document.getElementById('js_form_close').addEventListener('click', function(e){
                pressForm[0].classList.add("close-out");
            });
        });
    }

})();

function animateto(target){
var gotoTarget = offset(document.getElementById(target)).top - 80;
var from     = window.pageYOffset
var to       = gotoTarget
var duration = 1300;
var start = new Date().getTime()

/* Time Interval */
var timer = setInterval(function() {
    var time = new Date().getTime() - start

    if(from <= to ){
        var y = easeInOutQuart(time, from, to - from, duration)
    } else {

        var y = easeInOutQuart(time, from, -(from - to), duration)
    }
    window.scrollTo(0, y)
    if (time >= duration) clearInterval(timer)

}, 1000 / 60);

window.scrollTo(0, from)

}
/* Ease Movement */
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
/* ScrollW */
function scrollW(){
    /* check scroll down or up for header styles */
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(st > 80){
        if (st > lastScrollTop){
            /* downscroll code */
            if(!header.classList.contains('down')){
                header.classList.add('down');
                header.classList.remove('up');
            }
        } else {
            /* upscroll code */
            if(!header.classList.contains('up')){
                header.classList.add('up');
                header.classList.remove('down');
            }
        }
    } else {
        if(header.classList.contains('up') || header.classList.contains('down')){
            header.classList.remove('up');
            header.classList.remove('down');
        }
    }

    let SubMenu = document.getElementById('subMenuAnchor');
    if(SubMenu){
        let subPost = document.getElementById('subMenu');
        let subPosition = '';
        if(document.body.classList.contains('alert_open')){
            subPosition = offset(SubMenu).top - 120;
        } else {
            subPosition = offset(SubMenu).top - 80;
        }
        if(st > subPosition){
            if(!subPost.classList.contains('floating-up')){
                subPost.classList.add('floating-up');
            }
        } else {
            if(subPost.classList.contains('floating-up')) {
                subPost.classList.remove('floating-up');
            }
        }
    }

    lastScrollTop = st <= 0 ? 0 : st; /* For Mobile or negative scrolling */

}